import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import fallbackImage from '../../images/profileImage.jpg'
import { toggleLoader } from "../../shared/actions/setting";
import axios from "axios";
import { getUserId } from "../../shared/authentication/authentication";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { REPORT_TYPE } from "../../shared/util/enum";
import FeatherIcon from "feather-icons-react";
import {useParams} from "react-router-dom";

const formatValue = (value, suffix = "") => value === null || value === undefined ? "N/A" : `${value}${suffix}`;

const Employee = ({ data, overallPerformance }) =>{
    const employeeInfo = [
        {
            title:"EmpID",
            value:data.empId
        },
        {
            title:"Position",
            value:data.position
        },
        {
            title:"Contact",
            value:data.contactNo
        },

    ];

    return <Container className="d-flex w-full col flex-row shadow mb-3 border-radius-5 paddingValue-0">
        <Card className="d-flex w-25">
            <Card.Body className="text-center" >
            <Card.Img variant="left" width={100} height={100} src={data.imageUrl? "data:image/jpeg;base64,"+ data.imageUrl : fallbackImage} className="border-radius-10"/>
            <Card.Text className="font-weight-bold mt-3">{data.name ? data.name : "N/A"}</Card.Text>
            <Card.Text className="text-muted font-size-14">{`Employee Since: ${data.joinedDate ? data.joinedDate.split('T')[0] : "N/A"}`}</Card.Text>
            <Card className="border-radius-10">
                <Card.Body>
                    <Card.Text>Overall Performance</Card.Text>
                    <Card.Text className="font-weight-bold">{formatValue(overallPerformance, "%")}</Card.Text>
                </Card.Body>
            </Card>
            </Card.Body>
        </Card>
        <Card className="w-75">
            <Card.Body className="p-0">
                <div className="w-100 border-bottom pt-4 pl-4">
                    <label className="font-weight-bold">Personal information</label>
                    <div className="d-flex flex-row">
                    {
                        employeeInfo.map((item,index) =>{
                            return <div key={index} className="d-flex flex-column mr-5 p-2">
                                <label className="text-dark">{item.title}</label>
                                <label className="text-muted font-size-14">{item.value ? item.value : "N/A"}</label>
                            </div>
                        })
                    }
                    </div>
                </div>
                <div className="pt-4 pl-4">
                    <label className="font-weight-bold" >Accessible Department</label>
                    {
                        data.department && data.department.length > 0 ? 
                        <div className="d-flex flex-row">
                            {
                                data.department.map((item,index) => {
                                    return <div key={index} className="text-center d-flex flex-colum p-2 mr-2 bg-light border-radius-10 font-size-14">
                                        <label>{item.departmentName}</label>
                                    </div>
                                })
                            }
                        </div>
                        : <div>No departments</div>
                    }
                    
                </div>
            </Card.Body>
        </Card>
    </Container>
}

const JobPerformance = ({data, onSelect, selectedValue, machineList}) =>{
    const JobCard = ({job}) =>{
        const metrics = [
            {
                title:'Setup',
                value: job.setupTime?.performance
            },{
                title:'Running',
                value: job.runTime?.performance
            },{
                title:'Down',
                value: job.downTime?.performance
            },{
                title:'Wastage',
                value: job.wastage?.performance
            }
        ];

        return <Card className="border-radius-10">
            <Card.Header>
                <Card.Text className="font-weight-bold mb-0">
                    {job.jId ? job.jId : "N/A"}
                    <Card.Text className="font-weight-normal text-muted font-size-14">{`Machine: ${job.machineId ? job.machineId : "N/A"}`}</Card.Text>
                </Card.Text>
            </Card.Header>
            <Card.Body className="text-center report-card-background">
                <Card className="border-radius-10 mb-2">
                    <Card.Body className="text-center">
                        <Card.Text className="font-size-14 text-secondary">Overall Performance</Card.Text>
                        <Card.Text className="font-weight-bold font-size-14">{formatValue(job.overallPerformance, "%")}</Card.Text>
                    </Card.Body>
                </Card>
                <Row xs={2} md={4} className="mx-n1">
                {
                    metrics.map((item,index) =>{
                        return <Col key={index} className="px-1 mb-2">
                            {/* Equal heights, and titles on one line so "Wastage" doesn't break mid-word */}
                            <Card className="border-radius-10 h-100">
                                <Card.Body className="text-center px-1 py-2">
                                    <Card.Text className="text-secondary mb-1 text-nowrap" style={{fontSize: 13}}>{item.title}</Card.Text>
                                    <Card.Text className="font-weight-bold font-size-14">{formatValue(item.value, "%")}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    })
                }
                </Row>
            </Card.Body>
        </Card>
    }

    return <Card className="shadow mb-3">
        <Card.Header className="font-weight-bold d-flex flex-row justify-content-between">
            Job-Based Performance
            <select
              className={`form-control form-control-time-filter name-shift h-25 ml-1`}
              name="machine"
              onChange={(e) => onSelect(e.target.value)}
              style={{width:"12%"}}
              value={selectedValue || "Machine"}
            >
              <option>Machine</option>
              {
                machineList && machineList.map((item,index) =>{
                    return <option key={index}>{item}</option>
                })
              }
            </select>
        </Card.Header>
        <Card.Body>
        {
            data && data.length > 0 ?
            <Row xs={1} md={3} className="g-4">
            {
                data.map((item, idx) => (
                    <Col key={item.jobId || idx} className="mt-2">
                        <JobCard job={item}/>
                    </Col>
                ))
            }
            </Row>
            :<div className={"empty-results"}>
                <FeatherIcon icon="info"/>
                <div className={"empty-results-text"}>There are no jobs</div>
            </div>
        }
        </Card.Body>
    </Card>
}

const TimerCard = ({ data }) =>{

    const Timer = ({title, performance, estimated, archived}) =>{
        const timerValues = [
            {
                title:'Estimated Time',
                value: estimated
            },{
                title:'Archived Time',
                value: archived
            },{
                title:'Performance',
                value: performance,
                suffix: '%'
            }
        ];
        
        return <Card className="shadow border-radius-10">
            <Card.Header className="font-weight-bold">{title}</Card.Header>
            <Card.Body className="text-center report-card-background px-2" style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius:"10px"}}>
            <Row xs={3} className="mx-n1">
                {
                    timerValues.map((item,index) =>{
                       return <Col key={index} className="px-1">
                       <Card className="border-radius-10 h-100">
                        <Card.Body className="text-center px-1 py-2 d-flex flex-column">
                            {/* Wrap between whole words only; Bootstrap cards otherwise split long words */}
                            <Card.Text className="text-secondary mb-1" style={{fontSize: 12, overflowWrap: 'normal', wordBreak: 'normal'}}>{item.title}</Card.Text>
                            {/* Values sit at the bottom so they line up even when a title wraps */}
                            <Card.Text className="font-weight-bold font-size-14 mt-auto mb-0">{formatValue(item.value, item.suffix)}</Card.Text>
                        </Card.Body>
                        </Card>
                    </Col>
                    })
                }
            </Row>
            </Card.Body>
        </Card>
    }

    // Setup | Running | Down | Wastage share one row on wide screens, two per row on tablets
    return <Row xs={1} md={2} lg={4} className="g-4 mx-n1">
        <Col className="mt-2 px-1">
            <Timer 
                title={"Setup Time"} 
                archived={data?.setupTime && data.setupTime.archived} 
                performance={data?.setupTime && data.setupTime.performance} 
                estimated={data?.setupTime && data.setupTime.estimated}/>
        </Col>
        <Col className="mt-2 px-1">
            <Timer 
                title={"Running Time"} 
                archived={data?.runTime && data.runTime.archived} 
                performance={data?.runTime && data.runTime.performance} 
                estimated={data?.runTime && data.runTime.estimated}/>
        </Col>
        <Col className="mt-2 px-1">
            <Timer 
                title={"Down Time"} 
                archived={data?.downTime && data.downTime.archived} 
                performance={data?.downTime && data.downTime.performance} 
                estimated={data?.downTime && data.downTime.estimated}/>
        </Col>
        <Col className="mt-2 px-1">
            <Timer 
                title={"Wastage"} 
                archived={data?.wastage && data.wastage.archived} 
                performance={data?.wastage && data.wastage.performance} 
                estimated={data?.wastage && data.wastage.estimated}/>
        </Col>
    </Row>
}

const EmployeeReport = () =>{
    const dispatch = useDispatch();
    const {employeeID: employeeId} = useParams();
    const [employee , setEmployee] = useState({});
    const [machine, setMachine] = useState('');
    const [filteredPerformance,setFilteredPerformance] = useState({});
    const selectedGraphType = useSelector(state => {
        return state.reportList.selectedGraphType;
    });

    useEffect(() => {
        let isStale = false;
        setEmployee({});
        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/' + getUserId() + '/employee/'+ employeeId)
            .then(res => {
                if (!isStale) {
                    setEmployee(res.data.content || {});
                }
            }).catch(error => {
                if (!isStale) {
                    toast.error(error.response?.data?.message || "Failed to load employee");
                }
            }
        ).finally(() => {
            dispatch(toggleLoader(false))
        })

        return () => {
            isStale = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employeeId]);

    useEffect(() =>{
        onSelectReportType(selectedGraphType);
        setMachine('');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[employee, selectedGraphType])

    const onSelectReportType = (type) =>{
        switch (type) {
            case REPORT_TYPE.LAST_WEEK:
                setFilteredPerformance(employee.weekPerformance);
                break;
            case REPORT_TYPE.MONTHLY:
                setFilteredPerformance(employee.monthlyPerformance);
                break;
            case REPORT_TYPE.ANNUAL:
                setFilteredPerformance(employee.annualPerformance);
                break;
            case REPORT_TYPE.DAILY:
                setFilteredPerformance(employee.dailyPerformance);
                break;
            default:
                setFilteredPerformance(employee.weekPerformance);
                break;
        }
    }

    const jobs = filteredPerformance?.jobs || [];
    const machineList = [...new Set(jobs.map(job => job.machineId).filter(Boolean))];
    const filteredJobs = machine && machine !== "Machine" ? jobs.filter(job => job.machineId === machine) : jobs;

    return <div id="reportView" className={'list-view full-list-view'}>
        <Container className="m-t-8">
            <Employee data={employee} overallPerformance={filteredPerformance?.overallPerformance}/>
            <JobPerformance data={filteredJobs} machineList={machineList} onSelect={setMachine} selectedValue={machine}/>
            <TimerCard data={filteredPerformance}/>
            <Container style={{height:"10px"}}/>
        </Container>
    </div>
}

export default EmployeeReport;